import * as z from 'zod';
import {
    BILLING_CYCLES,
    BILLING_TIME,
    MEASUREMENT_TYPE,
    METERED_BILLING_STRATEGY,
    STATEFUL_BILLING_STRATEGY,
} from 'src/features/servicePlanBillingPolicies/utils/types';
import { validationMessagesMap } from 'src/utils/messages';

export type ServicePlanBillingPolicyFormSchemaValues = z.infer<typeof servicePlanBillingPolicyFormSchema>;
export const servicePlanBillingPolicyFormSchema = z
    .object({
        valid_from: z.string(),
        billing_cycle: z.enum(BILLING_CYCLES),
        billing_time: z.enum(BILLING_TIME),
        measurement_type: z.enum(MEASUREMENT_TYPE),
        valid_to: z.string().optional().nullable(),
        stateful_billing_strategy: z.enum(STATEFUL_BILLING_STRATEGY).optional().nullable(),
        metered_billing_strategy: z.enum(METERED_BILLING_STRATEGY).optional().nullable(),
        enable_proration: z.boolean(),
    })
    .superRefine((data, ctx) => {
        if (data.measurement_type === MEASUREMENT_TYPE.STATEFUL && !data.stateful_billing_strategy) {
            ctx.addIssue({
                path: ['stateful_billing_strategy'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
        if (data.measurement_type === MEASUREMENT_TYPE.METERED && !data.metered_billing_strategy) {
            ctx.addIssue({
                path: ['metered_billing_strategy'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
    });

export type PatchServicePlanBillingPolicyFormSchemaValues = z.infer<typeof patchServicePlanBillingPolicySchema>;
export const patchServicePlanBillingPolicySchema = servicePlanBillingPolicyFormSchema.partial();
